/**
 * Calculates profit/loss between two balance values
 * @param balanceStart - Starting balance
 * @param balanceEnd - Ending balance
 * @returns Formatted profit/loss string
 */
export const calculateProfitLoss = (
  balanceStart: number | null,
  balanceEnd: number | null,
): string => {
  if (balanceStart === null || balanceEnd === null) {
    return 'N/A';
  }
  const difference = balanceEnd - balanceStart;
  const sign = difference >= 0 ? '+' : '';
  return `${sign}$${difference.toFixed(2)}`;
};

/**
 * Calculates percentage change between two values
 * @param oldValue - The old value
 * @param newValue - The new value
 * @returns Percentage change as a number
 */
export const calculatePercentageChange = (
  oldValue: number,
  newValue: number,
): number => {
  if (oldValue === 0) return 0;
  return ((newValue - oldValue) / oldValue) * 100;
};

/**
 * Calculates the average of an array of numbers
 * @param numbers - Array of numbers
 * @returns Average value
 */
export const calculateAverage = (numbers: number[]): number => {
  if (numbers.length === 0) return 0;
  return numbers.reduce((sum, num) => sum + num, 0) / numbers.length;
};

/**
 * Rounds a number to a specified number of decimal places
 * @param value - The number to round
 * @param decimals - Number of decimal places
 * @returns Rounded number
 */
export const roundToDecimals = (value: number, decimals: number): number => {
  return Math.round(value * Math.pow(10, decimals)) / Math.pow(10, decimals);
};
